import request from '@/utils/request';

export async function getMenus(urlIndex) {
  return request(`/dirs/${urlIndex}/dirs`);
}

export async function getSonMenus(urlIndex) {
  return request(`/dirs/${urlIndex}/dirmenus`);
}

export async function qryActiveComponentInMenu(menuId) {
  return request(`/menus/${menuId}/components`);
}

export async function delComponent(componentId) {
  return request(`/components/${componentId}`, {
    method: 'DELETE',
  });
}

export async function modComponent(params) {
  return request('/components', {
    method: 'PUT',
    body: params,
  });
}
